"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIn = void 0;
const assertString_1 = require("./util/assertString");
const toString_1 = require("./util/toString");
function isIn(str, options) {
    (0, assertString_1.assertString)(str);
    let i;
    if (Array.isArray(options)) {
        const array = [];
        for (i in options) {
            // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
            // istanbul ignore else
            if ({}.hasOwnProperty.call(options, i)) {
                array[i] = (0, toString_1.toString)(options[i]);
            }
        }
        return array.indexOf(str) >= 0;
    }
    else if (typeof options === 'object') {
        return options.hasOwnProperty(str);
    }
    return false;
}
exports.isIn = isIn;
